import en from "./en";
import fr from "./fr";
import enExtends from "./extends/en";
import frExtends from "./extends/fr";

// we add prefix to follow reactadmin norms
const bpmnEn = { bpmn: { ...en, ...enExtends } };
const bpmnFr = { bpmn: { ...fr, ...frExtends } };

export { bpmnEn, bpmnFr }